import React from "react";
import { Grid } from "@material-ui/core";

import { CheckBox } from "components/Form/FormikControls";
import {
  FinancialStatementForm,
  FinancialStatementFormValues,
} from "components/MultiSaleReports/ManyReportsForm/FinancialStatementReports/Form";

export interface DetailedFinancialStatementFormValues
  extends FinancialStatementFormValues {
  showStockDetails: boolean;
}

type DetailedFinancialStatementFormProps = {
  namespace?: string;
};

export function DetailedFinancialStatementForm(
  props: DetailedFinancialStatementFormProps,
): React.JSX.Element {
  const { namespace: ns = "" } = props;

  return (
    <>
      <FinancialStatementForm namespace={ns} />
      <Grid item xs={12}>
        <CheckBox name="showStockDetails" label="Show Stock Details" />
      </Grid>
    </>
  );
}
